export default "__VITE_ASSET__CpNY_wka__"